/**
 * @generated SignedSource<<b2ef2fde713507dbf018acf99cdd24e5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type deploymentTooltipContent_softwareReleasesLaunchCard_jiraVersion$data = {
  readonly name: string;
  readonly project: {
    readonly key: string;
  };
  readonly " $fragmentType": "deploymentTooltipContent_softwareReleasesLaunchCard_jiraVersion";
};
export type deploymentTooltipContent_softwareReleasesLaunchCard_jiraVersion$key = {
  readonly " $data"?: deploymentTooltipContent_softwareReleasesLaunchCard_jiraVersion$data;
  readonly " $fragmentSpreads": FragmentRefs<"deploymentTooltipContent_softwareReleasesLaunchCard_jiraVersion">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "deploymentTooltipContent_softwareReleasesLaunchCard_jiraVersion",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "name"
      },
      "action": "THROW",
      "path": "name"
    },
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "kind": "ScalarField",
              "name": "key"
            },
            "action": "THROW",
            "path": "project.key"
          }
        ]
      },
      "action": "THROW",
      "path": "project"
    }
  ],
  "type": "JiraVersion"
};

(node as any).hash = "fc05ee90d6c0521ade9b87e6185e0b92";

export default node;
